import { useGameStore } from '../../store';
import { fmt } from '../../utils/format';

export default function LaborSummaryModal() {
  const show              = useGameStore((s) => s.showLaborSummaryModal);
  const earnings          = useGameStore((s) => s.laborSessionEarnings);
  const closeLaborSummary = useGameStore((s) => s.closeLaborSummary);

  if (!show) return null;

  return (
    <div className="modal-backdrop center" style={{ zIndex: 200, display: 'flex' }}>
      <div className="modal-sheet mid">
        <div className="modal-title">⛏️ 노역 결산</div>
        <div className="modal-body" style={{ textAlign: 'center' }}>
          {earnings > 0 ? (
            <>
              이번 노역으로 획득한 냥<br /><br />
              <strong style={{ color: 'var(--gold)', fontSize: 22 }}>
                +{fmt(earnings)}냥
              </strong>
            </>
          ) : (
            '이번 노역에선 아무것도 얻지 못했소.'
          )}
        </div>
        <button className="modal-btn" onClick={closeLaborSummary}>확인</button>
      </div>
    </div>
  );
}
